import React from "react";

const MutedForMeInSpace = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.14844 8.124C1.14844 7.20012 1.89739 6.45117 2.82127 6.45117H5.09154V11.2966H2.82127C1.89739 11.2966 1.14844 10.5477 1.14844 9.62378V8.124Z"
        fill="black"
      />
      <path
        d="M2.46289 8.8738L7.88465 3.77832V13.9692L2.46289 8.8738Z"
        fill="black"
      />
      <path
        d="M10.3496 5.06738C12.9781 7.47189 12.9784 10.6779 10.3498 12.6816"
        stroke="black"
      />
      <path
        d="M12.9766 2.29883C16.4814 6.45206 16.4817 11.9897 12.977 15.4507"
        stroke="black"
      />
      <path
        d="M15.8136 13.2555L3.98047 2.45215L2.76277 3.78592L14.5959 14.5892L15.8136 13.2555Z"
        fill="black"
      />
    </svg>
  );
};

export default MutedForMeInSpace;
